import { exportToBlob } from "@excalidraw/excalidraw";

import type { NonDeletedExcalidrawElement } from "@excalidraw/element/types";
import type { AppState, BinaryFiles } from "@excalidraw/excalidraw/types";

const THUMB_MAX_EDGE = 512;

/**
 * Render the current scene to a PNG thumbnail Blob, capped to ~512px on the
 * long edge. Client-side generation (requirement THUMB-1).
 */
export const generateThumbnail = async (
  elements: readonly NonDeletedExcalidrawElement[],
  appState: Partial<AppState>,
  files: BinaryFiles,
): Promise<Blob> => {
  return exportToBlob({
    elements,
    appState: {
      ...appState,
      exportBackground: true,
      exportWithDarkMode: false,
    },
    files,
    mimeType: "image/png",
    getDimensions: (width: number, height: number) => {
      const longEdge = Math.max(width, height) || 1;
      const scale = Math.min(1, THUMB_MAX_EDGE / longEdge);
      return { width, height, scale };
    },
  });
};
